export default __webpack_public_path__ + "static/media/powered-by.b519e1ca.svg";